export default __webpack_public_path__ + "static/image5-79f6a659096708da356a497c42b0f12b.jpg";